<template>
  <footer class="e-footer">
    <supporters class="e-footer__supporters" />
    <span class="e-brand-name">
      <Logo class="e-brand-name--white" aria-label="Logo" />
      <LogoOrig class="e-brand-name--orig e-tablet-hidden" aria-label="Logo" />
    </span>
  </footer>
</template>

<script>
import Supporters from 'atoms/Supporters/Supporters'

// Icons
import Logo from 'assets/icons/logo-ngk-white.svg'
import LogoOrig from 'assets/icons_orig/logo-ngk-orig.svg'

export default {
  name: 'TheFooter',
  components: {
    Logo,
    LogoOrig,
    Supporters
  }
}
</script>

<style lang="scss" scoped>
@import '_assets/footer';
</style>
